import { useNavigate } from "react-router-dom";
import { ProductGrid } from "../product";
import { SEO } from "../SEO";

export function AnimeSection({ products, isPage }) {
  const navigate = useNavigate();
  const animeProducts = products.filter(p => p.collection === "Anime");
  
  const taglines = [
    "Anime in the Streets.",
    "Drip Like Your Favorite Character.",
    "Main Character Energy.",
    "Level Up Your Style."
  ];
  
  return (
    <section className={`py-20 px-4 ${isPage ? 'pt-32' : ''} bg-gradient-to-b from-zinc-900 to-black`} data-testid="anime-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          {isPage && <SEO title="Anime Collection" description="Fresh Po'Boy Anime Collection. Anime-inspired streetwear for the culture. Premium tees & hoodies." path="/anime" />}
          <span className="text-cyan-400 text-sm tracking-widest uppercase">New Collection</span>
          <h2 className="text-white text-5xl sm:text-6xl font-bebas mt-2">Anime <span className="text-cyan-400">Collection</span></h2>
          <p className="text-white/60 mt-4 max-w-xl mx-auto">Where streetwear meets anime culture.</p>
        </div>
        
        {isPage && (
          <div className="mb-16">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {taglines.map((tagline, index) => (
                <div 
                  key={tagline} 
                  className={`p-4 rounded-xl ${index % 2 === 0 ? 'bg-cyan-400/10 border border-cyan-400/30' : 'bg-red-600/10 border border-red-600/30'} text-center`}
                >
                  <p className={`text-sm sm:text-base font-bold ${index % 2 === 0 ? 'text-cyan-400' : 'text-red-500'}`}>
                    "{tagline}"
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}
        
        <ProductGrid products={animeProducts} />
        {!isPage && animeProducts.length > 0 && (
          <div className="text-center mt-12">
            <button onClick={() => navigate('/anime')} className="px-8 py-4 bg-cyan-400 text-black font-semibold hover:bg-cyan-300 transition-colors" data-testid="view-anime-collection-btn">View Full Collection</button>
          </div>
        )}
      </div>
    </section>
  );
}
